export const GET_APPLESMSLINK = "GET_APPLESMSLINK";
export const GET_APPLESMSLINK_SUCCESS = "GET_APPLESMSLINK_SUCCESS";
export const GET_APPLESMSLINK_FAIL = "GET_APPLESMSLINK_FAIL";

export const ADD_APPLESMSLINK_SUCCESS = "ADD_APPLESMSLINK_SUCCESS";
export const UPDATE_APPLESMSLINK_SUCCESS = "UPDATE_APPLESMSLINK_SUCCESS";
export const DELETE_APPLESMSLINK_SUCCESS = "DELETE_APPLESMSLINK_SUCCESS";
